export default [
    {
        name: 'administracao-configuracao-sistema',
        path: 'configuracao-sistema',
        redirect: 'configuracao-sistema/edit',
        component: () => import(/* webpackChunkName: 'administracao-configuracao-sistema' */ '@/views/administracao/configuracao-sistema/Index'),
        children: [
            {
                meta: {title: 'Edição da configuração do sistema'},
                name: 'administracao-configuracao-sistema-edit',
                path: 'edit',
                component: () => import(/* webpackChunkName: 'administracao-configuracao-sistema' */ '@/views/administracao/configuracao-sistema/Form'),
            },
        ],
    },
]